import { lazy } from 'react';
import Loadable from 'components/Loadable';
import StaticEmployeeMaster from 'static-solutions/24155/identity-solution/employee-master/index';
import StaticCOEEmployeeMaster from 'static-solutions/24155/identity-solution/employee-master/COE-Employee';
import StaticDetailsEmployeeMaster from 'static-solutions/24155/identity-solution/employee-master/Details-Employee';
import StaticProcessRoleEdit from 'static-solutions/24155/identity-solution/processrole-master/Edit';
import StaticProcessRoleMaster from 'static-solutions/24155/identity-solution/processrole-master/index';
import StaticProcessRoleCreate from 'static-solutions/24155/identity-solution/processrole-master/Create';
import StaticProcessRoleDetails from 'static-solutions/24155/identity-solution/processrole-master/Details';
import StaticCommittee from 'static-solutions/24155/identity-solution/committee/index';
import StaticCOECommittee from 'static-solutions/24155/identity-solution/committee/COECommittee';
import StaticCommitteeEdit from 'static-solutions/24155/identity-solution/committee/Edit';
import StaticDetailsCommittee from 'static-solutions/24155/identity-solution/committee/DetailsCommittee';
import StaticLeave from 'static-solutions/24155/policy-solution/leave-combined/Create';
import StaticAnnualLeaveCreate from 'static-solutions/24155/policy-solution/leave/Create';
import StaticLeaveUpdate from 'static-solutions/24155/policy-solution/leave-combined/Update';
import StaticLeaveDetails from 'static-solutions/24155/policy-solution/leave-combined/Details';
import StaticControlQuestionnaire from 'static-solutions/24155/identity-solution/control-questionnaire/Create';
import StaticAssignControlQuestionnaire from 'static-solutions/24155/identity-solution/assign-control-questionnaire/Create';
import AssignControlSelfAssurance from 'static-solutions/24155/policy-solution/assign-control-for-self-assurance/Create';
import StaticLeaseRecordSimulator from 'static-solutions/24155/identity-solution/lease-simulator/CreateNew';
import StaticLeaseRecordManagement from 'static-solutions/24155/identity-solution/lease-record-management/Create';
import StaticLeaseRecordManagementEdit from 'static-solutions/24155/identity-solution/lease-record-management/Edit';
import StaticLeaseRecordManagementV2 from 'static-solutions/24155/identity-solution/lease-record-management-v2/Create';
import StaticLeaseRecordManagementEditV2 from 'static-solutions/24155/identity-solution/lease-record-management-v2/Edit';
import StaticDecommissionAssetV6 from 'static-solutions/24155/identity-solution/decommission-asset/Create';
import StaticDecommissionAssetEditV6 from 'static-solutions/24155/identity-solution/decommission-asset/Edit';
import StaticDecommissionAssetReviseV6 from 'static-solutions/24155/identity-solution/decommission-asset/Revise';
import StaticLeaseRecordManagementV6 from 'static-solutions/24155/identity-solution/lease-record-management-v6/Create';
import StaticLeaseRecordManagementEditV6 from 'static-solutions/24155/identity-solution/lease-record-management-v6/Edit';
import StaticLeaseRecordManagementDecommissionAssetV6 from 'static-solutions/24155/identity-solution/decommission-asset/index';
import StaticLeaseRecordManagementDataTableV6 from 'static-solutions/24155/identity-solution/lease-record-management-v6/index';
import CombinedLeaveListPage from 'static-solutions/24155/policy-solution/leave-combined/index.jsx';
import StaticLeaseRecordManagementV7 from 'static-solutions/24155/identity-solution/lease-record-management-v7/Create';
import StaticLeaseRecordManagementEditV7 from 'static-solutions/24155/identity-solution/lease-record-management-v7/Edit';
import AssignControlSelfAssuranceV2 from 'static-solutions/24155/policy-solution/assign-control-for-self-assurance-v2/CreateV2';
import StaticControlTesting from 'static-solutions/24155/identity-solution/control-testing/Create';
import StaticFloatCreationCreate from 'static-solutions/25118/identity-solution/float-creation/Create';

// Attendance Solution Static
import StaticAttendanceShiftCreate from 'static-solutions/24155/policy-solution/shift/Create';
import AttendanceManagement from 'static-solutions/24155/console-solution/attendance-management/index';
import StaticControl from 'static-solutions/24155/console-solution/control/index';
import BudgetaryControl from 'static-solutions/24155/console-solution/budgetary-control/index';
import ControlSelfAssurance from 'static-solutions/24155/console-solution/control-self-assurance/index';
import ControlSelfAssuranceV2 from 'static-solutions/24155/console-solution/compliance-tracker/index';
import LeaseRecordManagementV9Edit from 'static-solutions/24155/identity-solution/lease-v9-new-version/lease-record-management-v9-new-version/edit/LeaseRecordManagementV9Edit';
import LeaseRecordManagementV9Modify from 'static-solutions/24155/identity-solution/lease-v9-new-version/lease-record-management-v9-new-version/modify/LeaseRecordManagementV9Modify';
import LeaseRecordManagementV9Details from 'static-solutions/24155/identity-solution/lease-v9-new-version/lease-record-management-v9-new-version/details/LeaseRecordManagementV9Details';
import LeaseTrailModeV9NewCreate from 'static-solutions/24155/identity-solution/lease-v9-new-version/lease-trail-mode-v9-new/create/LeaseV9NewTrailModeCreate';
import LeaseV9NewTrailModeView from '../static-solutions/24155/identity-solution/lease-v9-new-version/lease-trail-mode-v9-new/view/LeaseV9NewTrailModeView';
import LeaseV9NewTrailModeModify from '../static-solutions/24155/identity-solution/lease-v9-new-version/lease-trail-mode-v9-new/modify/LeaseV9NewTrailModeModify';
import KpiComparativeConsole from 'static-solutions/24155/console-solution/kpi-comparative-console/index';

const LeaseSchedule = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-schedule/index')));
const LeaveManagement = Loadable(lazy(() => import('static-solutions/24155/console-solution/leave-management/index')));
const AttendanceSummary = Loadable(lazy(() => import('static-solutions/24155/console-solution/my-attendance/index')));
const StaticLeaseAgreement = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-agreement/Create')));
const StaticLeaseAgreementDetails = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-agreement/Details')));
const StaticLeaseAgreementEdit = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-agreement/Edit')));
const StaticTaskAttachment = Loadable(lazy(() => import('static-solutions/24155/identity-solution/task-attachment/Create')));
const StaticTaskAttachmentEditAndDetails = Loadable(lazy(() => import('static-solutions/24155/identity-solution/task-attachment/Edit')));
const StaticGeneralLedgerCodeCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/general-ledger-code/Create')));
const StaticGeneralLedgerCode = Loadable(lazy(() => import('static-solutions/24155/identity-solution/general-ledger-code/Edit')));
const StaticGeneralLedgerCodeCreateV2 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/general-ledger-code-v2/Create')));
const StaticGeneralLedgerCodeEditV2 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/general-ledger-code-v2/Edit')));
const StaticCostCenterCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/cost-center/Create')));
const StaticCostCenterCreateV2 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/cost-center-v2/Create')));
const StaticCostCenter = Loadable(lazy(() => import('static-solutions/24155/identity-solution/cost-center/Edit')));
const StaticCostCenterV2 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/cost-center-v2/Edit')));
const StaticLeaseRecordManagementV4 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-record-management-v4/Create')));
const StaticLeaseRecordManagementEditV4 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-record-management-v4/Edit')));
const StaticLeaseRecordManagementCreationV5 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-record-management-v5/Create'))
);
const StaticLeaseRecordManagementEditV5 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-record-management-v5/Edit')));
const StaticLeaseRecordManagementViewV5 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-record-management-v5/Create')));
const StaticLeaseRecordManagementReviseV5 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-record-management-v5/Revise'))
);
const StaticLeaseRecordManagementReviseV6 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-record-management-v6/Revise'))
);
const StaticLeaseRecordManagementReviseV7 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-record-management-v7/Revise'))
);

//lease-test-bed
const StaticLeaseRecordManagementTestBedCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-test-bed/Create')));
const StaticLeaseRecordManagementTestBedDetails = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-test-bed/Create')));
const StaticLeaseRecordManagementTestBedEdit = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-test-bed/Edit')));
// Add this if revise functionality is needed
const StaticLeaseRecordManagementTestBedRevise = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-test-bed/Revise')));
const StaticAccessControl = Loadable(lazy(() => import('static-solutions/24155/identity-solution/access-control/Create')));
const StaticDocumentGroup = Loadable(lazy(() => import('static-solutions/24155/identity-solution/document-group/Create')));
const StaticDocumentHierarchy = Loadable(lazy(() => import('static-solutions/24155/identity-solution/document-hierarchy/Create')));
const StaticDocumentUploader = Loadable(lazy(() => import('static-solutions/24155/identity-solution/document-uploader/Create')));
// const AttendancePolicyCreate = Loadable(lazy(() => import('static-solutions/24155/policy-solution/attendance/Create')));
const AccountsAssignmentPolicyCreate = Loadable(lazy(() => import('static-solutions/24155/policy-solution/accounts-assignment/Create')));
const AccountsAssignmentPolicy = Loadable(lazy(() => import('static-solutions/24155/policy-solution/accounts-assignment/Edit')));
const AccountsAssignmentPolicyCreateV2 = Loadable(lazy(() => import('static-solutions/24155/policy-solution/accounts-assignment-v2/Create')));
const AccountsAssignmentPolicyEditV2 = Loadable(lazy(() => import('static-solutions/24155/policy-solution/accounts-assignment-v2/Edit')));
const CostCenterPolicyCreate = Loadable(lazy(() => import('static-solutions/24155/policy-solution/cost-center-assignment/Create')));
const CostCenterPolicyCreateV2 = Loadable(lazy(() => import('static-solutions/24155/policy-solution/cost-center-assignment-v2/Create')));
const CostCenterPolicy = Loadable(lazy(() => import('static-solutions/24155/policy-solution/cost-center-assignment/Edit')));
const CostCenterPolicyV2 = Loadable(lazy(() => import('static-solutions/24155/policy-solution/cost-center-assignment-v2/Edit')));
const PerformanceParameterCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/performanceParameter/Create')));
const LeaseSecondConsoleV2 = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-schedule-v2/index')));
const LeaseSecondConsoleV4 = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-schedule-v4/index')));
const LeaseSecondConsoleV5 = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-schedule-v5/index')));
const LeaseSecondConsoleV6 = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-schedule-v6/index')));
const DecommissionAssetAccounting = Loadable(lazy(() => import('static-solutions/24155/console-solution/decommission-asset-accounting/index')));
const LeaseSecondConsoleV7 = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-schedule-v7/index')));
const ListViewPettyCashFloatConsole = Loadable(lazy(() => import('static-solutions/25118/console-solution/ListViewPettyCashFloatDashboard/index')));
const ListViewPettyCashReconciliationConsole = Loadable(
	lazy(() => import('static-solutions/25118/console-solution/ListViewPettyCashReconciliationDashboard/index'))
);
const ListViewPettyCashTransactionConsole = Loadable(
	lazy(() => import('static-solutions/25118/console-solution/ListViewPettyCashTransaction/index'))
);
const PettyCashTransactionForCasher = Loadable(
	lazy(() => import('static-solutions/25118/console-solution/ListViewPettyCashTransaction/ListViewPettyCashTransaction'))
);
const KpiConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/kpi-console')));
const TeamKpiEvaluationStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/team-kpi-evaluation')));
const SalaryManagementConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/salary-management')));
const LeadPipelineConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/lead-pipeline')));
const LeadKanbanConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/lead-kanban')));
const LeadIngestionPoolConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/lead-ingestion-pool')));
const LeadScreeningConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/lead-screening')));
const LeadAssignmentConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/lead-assignment')));
const LeadWorkbenchConsoleStatic = Loadable(lazy(() => import('static-solutions/24155/console-solution/lead-workbench')));
const StaticRosterShiftsPolicy = Loadable(lazy(() => import('static-solutions/24155/policy-solution/roster-shifts')));
const StaticRosterShiftsPolicyEdit = Loadable(lazy(() => import('static-solutions/24155/policy-solution/roster-shifts/Edit')));
const StaticRosterShiftsPolicyDetails = Loadable(lazy(() => import('static-solutions/24155/policy-solution/roster-shifts/Details')));

// KPI Components Import
const StaticKeyPerformanceIndicator = Loadable(lazy(() => import('static-solutions/24155/identity-solution/key-performance-indicator/Create')));
const StaticKpiEvolution = Loadable(lazy(() => import('static-solutions/24155/identity-solution/kpi-evaluation/Create')));

// DMS
// Vendor Invoice Submission.
const StaticVendorInvoiceSubmission = Loadable(lazy(() => import('static-solutions/24155/identity-solution/vendor-invoice-submission/Create')));
const StaticVendorInvoiceSubmissionViewAndEdit = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/vendor-invoice-submission/Details'))
);
// Invoice Command Center
const StaticInvoiceCommandCenter = Loadable(lazy(() => import('static-solutions/24155/identity-solution/invoice-command-center/Details')));
// Invoice AP Console
const StaticInvoiceAPConsole = Loadable(lazy(() => import('static-solutions/24155/console-solution/invoice-ap-console/Details')));
const InvoiceAPConsole = Loadable(lazy(() => import('static-solutions/24155/console-solution/invoice-ap-console/index')));
// Invoice Treasury Console
const StaticInvoiceTreasuryConsole = Loadable(lazy(() => import('static-solutions/24155/console-solution/invoice-treasury-console/Details')));
const InvoiceTreasuryConsole = Loadable(lazy(() => import('static-solutions/24155/console-solution/invoice-treasury-console/index')));

// Common Escalation Matrix
const StaticCommonEscalationMatrixCreate = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/common-escalation-matrix/CommonEscalationMatrixCreate'))
);
const StaticCommonEscalationMatrixEdit = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/common-escalation-matrix/CommonEscalationMatrixEdit'))
);
const ListViewFixedAssetRegisterConsole = Loadable(lazy(() => import('static-solutions/24155/console-solution/fixed-asset-register/index')));

/* ================================ Lease V9 Component Import Start ================================= */

const StaticLeaseRecordManagementDataTableV9 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-management-v9/index'))
);
const StaticLeaseRecordManagementV9 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-management-v9/Create'))
);
const StaticLeaseRecordManagementEditV9 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-management-v9/Edit'))
);
const StaticLeaseRecordEditListV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-edit-v9/index')));
const StaticLeaseRecordEditViewV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-edit-v9/Create')));
const StaticLeaseRecordEditV9 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-edit-v9/LeaseRecordEditPage'))
);
const StaticLeaseRecordModifyListV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-modify-v9/index')));
const StaticLeaseRecordModifyViewV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-modify-v9/Create')));
const StaticLeaseRecordModifyV9 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-modify-v9/LeaseRecordModifyPage'))
);
const StaticLeaseRecordManagementReviseV9 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-record-management-v9/Revise'))
);
const StaticGeneralLedgerCodeCreateV9 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-v9/general-ledger-code-v9/Create'))
);
const StaticGeneralLedgerCodeEditV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/general-ledger-code-v9/Edit')));
const AccountsAssignmentPolicyCreateV9 = Loadable(
	lazy(() => import('static-solutions/24155/policy-solution/lease-v9/accounts-assignment-v9/Create'))
);
const AccountsAssignmentPolicyEditV9 = Loadable(lazy(() => import('static-solutions/24155/policy-solution/lease-v9/accounts-assignment-v9/Edit')));
const StaticCostCenterCreateV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/cost-center-v9/Create')));
const StaticCostCenterV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/cost-center-v9/Edit')));
const CostCenterPolicyCreateV9 = Loadable(lazy(() => import('static-solutions/24155/policy-solution/lease-v9/cost-center-assignment-v9/Create')));
const CostCenterPolicyV9 = Loadable(lazy(() => import('static-solutions/24155/policy-solution/lease-v9/cost-center-assignment-v9/Edit')));
const StaticLeaseAgreementV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-agreement-v9/Create')));
const StaticLeaseAgreementDetailsV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-agreement-v9/Details')));
const StaticLeaseAgreementEditV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-agreement-v9/Edit')));
const StaticLeaseRecordSimulatorV9 = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-simulator-v9/CreateNew')));
// Add this if revise functionality is needed
const StaticLeaseRecordManagementTestBedReviseV9 = Loadable(
	lazy(() => import('static-solutions/24155/identity-solution/lease-v9/lease-test-bed-v9/Revise'))
);
const LeaseSecondConsoleV9 = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-v9/lease-schedule-v9/index')));
const LeaseAccountingV10 = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-v9/lease-accounting-v10/index')));
const StaticGeneralLedgerCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/general-ledger/Create')));
const StaticGeneralLedgerView = Loadable(lazy(() => import('static-solutions/24155/identity-solution/general-ledger/Edit')));
const StaticGeneralLedgerEdit = Loadable(lazy(() => import('static-solutions/24155/identity-solution/general-ledger/Edit')));
const StaticLeasePayableV9Console = Loadable(lazy(() => import('static-solutions/24155/console-solution/lease-v9/lease-payable-v9/LeasePayableV9')));
const StaticLeasePayableApprovalV9Console = Loadable(
	lazy(() => import('static-solutions/24155/console-solution/lease-v9/lease-payable-approval-v9/LeasePayableApprovalV9'))
);
const StaticTaxPayableConsole = Loadable(lazy(() => import('static-solutions/24155/console-solution/tax-payable/TaxPayable')));
const StaticAssetMasterDataCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/asset-master-data/Create')));
const StaticAssetMasterDataView = Loadable(lazy(() => import('static-solutions/24155/identity-solution/asset-master-data/Edit')));
const StaticProcessGroupRoleCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/process-group-roles/Create')));
const ActingPositionOverview = Loadable(lazy(() => import('static-solutions/24155/console-solution/acting-position-overview/index')));
const RateAgreement = Loadable(lazy(() => import('static-solutions/24155/console-solution/rate-agreement/index')));
const ProjectMilestone = Loadable(lazy(() => import('static-solutions/24155/console-solution/project-milestone/index')));
const RentalSubscription = Loadable(lazy(() => import('static-solutions/24155/console-solution/rental-subscription/index')));
const ConsolidatedContractAdministration = Loadable(lazy(() => import('static-solutions/24155/console-solution/contract-administration/index')));
const LeadConfigurationIndex = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lead-configuration/index')));
const LeadConfigurationCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lead-configuration/Create')));
const LeadConfigurationEdit = Loadable(lazy(() => import('static-solutions/24155/identity-solution/lead-configuration/Edit')));
const JobAdvertisementIndex = Loadable(lazy(() => import('static-solutions/24155/identity-solution/job-advertisement/index')));
const JobAdvertisementCreate = Loadable(lazy(() => import('static-solutions/24155/identity-solution/job-advertisement/Create')));
const JobAdvertisementEdit = Loadable(lazy(() => import('static-solutions/24155/identity-solution/job-advertisement/Edit')));

/* ================================ Lease V9 Component Import End ================================= */

const StaticSolutionRoutes = [
	{
		path: 'static',
		children: [
			{
				path: 'employee',
				children: [
					{
						index: true,
						element: <StaticEmployeeMaster />,
					},
					{
						path: ':id',
						element: <StaticEmployeeMaster />,
					},
					{
						path: 'create',
						element: <StaticCOEEmployeeMaster />,
					},
					{
						path: 'edit',
						element: <StaticCOEEmployeeMaster />,
					},
					{
						path: 'details',
						element: <StaticDetailsEmployeeMaster />,
					},
				],
			},
			{
				path: 'process-role',
				children: [
					{
						index: true,
						element: <StaticProcessRoleMaster />,
					},
					{
						path: ':id',
						element: <StaticProcessRoleMaster />,
					},
					{
						path: 'create',
						element: <StaticProcessRoleCreate />,
					},
					{
						path: 'edit',
						element: <StaticProcessRoleEdit />,
					},
					{
						path: 'details',
						element: <StaticProcessRoleDetails />,
					},
				],
			},
			{
				path: 'committee',
				children: [
					{
						index: true,
						element: <StaticCommittee />,
					},
					{
						path: ':id',
						element: <StaticCommittee />,
					},
					{
						path: 'create',
						element: <StaticCOECommittee />,
					},
					{
						path: 'edit',
						element: <StaticCommitteeEdit screen="edit" />,
					},
					{
						path: 'details',
						element: <StaticCommitteeEdit screen="view" />,
					},
				],
			},
			{
				path: 'lead-configuration',
				children: [
					{
						index: true,
						element: <LeadConfigurationIndex />,
					},
					{
						path: ':id',
						element: <LeadConfigurationIndex />,
					},
					{
						path: 'create',
						element: <LeadConfigurationCreate />,
					},
					{
						path: 'edit',
						element: <LeadConfigurationEdit screen="edit" />,
					},
					{
						path: 'details',
						element: <LeadConfigurationEdit screen="view" />,
					},
				],
			},
			{
				path: 'job-advertisement',
				children: [
					{
						index: true,
						element: <JobAdvertisementIndex />,
					},
					{
						path: ':id',
						element: <JobAdvertisementIndex />,
					},
					{
						path: 'create',
						element: <JobAdvertisementCreate />,
					},
					{
						path: 'edit',
						element: <JobAdvertisementEdit screen="edit" />,
					},
					{
						path: 'details',
						element: <JobAdvertisementEdit screen="view" />,
					},
				],
			},
			{
				path: 'key-management-area',
			},
			{
				path: 'float-creation',
				children: [
					{
						path: 'create',
						element: <StaticFloatCreationCreate />,
					},
				],
			},
			{
				path: 'control-questionnaire',
				children: [
					{
						path: 'create',
						element: <StaticControlQuestionnaire />,
					},
				],
			},
			{
				path: 'assign-control-questionnaire',
				children: [
					{
						path: 'create',
						element: <StaticAssignControlQuestionnaire />,
					},
				],
			},
			{
				path: 'lease-record-management',
				children: [
					{
						path: 'create',
						element: <StaticLeaseRecordManagement screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordManagement screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordManagementEdit />,
					},
				],
			},
			{
				path: 'lease-record-management-v2',
				children: [
					{
						path: 'create',
						element: <StaticLeaseRecordManagementV2 screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordManagementV2 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordManagementEditV2 />,
					},
				],
			},
			{
				path: 'lease-record-management-v6',
				children: [
					{
						index: true,
						path: ':id',
						element: <StaticLeaseRecordManagementDataTableV6 />,
					},
					{
						path: 'create',
						element: <StaticLeaseRecordManagementV6 screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordManagementV6 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordManagementEditV6 screen="EDIT" />,
					},
					{
						path: 'revise',
						element: <StaticLeaseRecordManagementReviseV6 screen="REVISE" />,
					},
				],
			},
			{
				path: 'decommission-asset',
				children: [
					{
						index: true,
						path: ':id',
						element: <StaticLeaseRecordManagementDecommissionAssetV6 />,
					},
					{
						path: 'create',
						element: <StaticDecommissionAssetV6 screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticDecommissionAssetV6 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticDecommissionAssetEditV6 screen="EDIT" />,
					},
					{
						path: 'revise',
						element: <StaticDecommissionAssetReviseV6 screen="REVISE" />,
					},
				],
			},
			{
				path: 'lease-record-management-v7',
				children: [
					{
						path: 'create',
						element: <StaticLeaseRecordManagementV7 screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordManagementV7 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordManagementEditV7 screen="EDIT" />,
					},
					{
						path: 'revise',
						element: <StaticLeaseRecordManagementReviseV7 screen="REVISE" />,
					},
				],
			},
			{
				path: 'lease-record-management-v4',
				children: [
					{
						path: 'create',
						element: <StaticLeaseRecordManagementV4 screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordManagementV4 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordManagementEditV4 />,
					},
				],
			},
			{
				path: 'lease-record-management-v5',
				children: [
					{
						path: 'create',
						element: <StaticLeaseRecordManagementCreationV5 screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordManagementViewV5 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordManagementEditV5 screen="EDIT" />,
					},
					{
						path: 'revise',
						element: <StaticLeaseRecordManagementReviseV5 screen="REVISE" />,
					},
				],
			},
			{
				path: 'lease-simulator',
				children: [
					{
						path: 'create',
						element: <StaticLeaseRecordSimulator />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordSimulator screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordSimulator screen="EDIT" />,
					},
				],
			},
			{
				path: 'lease-test-bed',
				children: [
					{
						path: 'create',
						element: <StaticLeaseRecordManagementTestBedCreate screen="CREATE" />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordManagementTestBedDetails screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordManagementTestBedEdit screen="EDIT" />,
					},
					{
						path: 'revise',
						element: <StaticLeaseRecordManagementTestBedRevise screen="REVISE" />,
					},
				],
			},
			{
				path: 'lease-agreement',
				children: [
					{
						path: 'create',
						element: <StaticLeaseAgreement />,
					},
					{
						path: 'details',
						element: <StaticLeaseAgreementDetails />,
					},
					{
						path: 'edit',
						element: <StaticLeaseAgreementEdit screen="EDIT" />,
					},
				],
			},
			{
				path: 'task-attachment',
				children: [
					{
						path: 'create',
						element: <StaticTaskAttachment />,
					},
					{
						path: 'details',
						element: <StaticTaskAttachmentEditAndDetails screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticTaskAttachmentEditAndDetails screen="EDIT" />,
					},
				],
			},
			{
				path: 'general-ledger-code',
				children: [
					{
						path: 'create',
						element: <StaticGeneralLedgerCodeCreate />,
					},
					{
						path: 'details',
						element: <StaticGeneralLedgerCode screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticGeneralLedgerCode screen="EDIT" />,
					},
				],
			},
			{
				path: 'general-ledger-code-v2',
				children: [
					{
						path: 'create',
						element: <StaticGeneralLedgerCodeCreateV2 />,
					},
					{
						path: 'details',
						element: <StaticGeneralLedgerCodeEditV2 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticGeneralLedgerCodeEditV2 screen="EDIT" />,
					},
				],
			},
			{
				path: 'cost-center',
				children: [
					{
						path: 'create',
						element: <StaticCostCenterCreate />,
					},
					{
						path: 'details',
						element: <StaticCostCenter screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticCostCenter screen="EDIT" />,
					},
				],
			},
			{
				path: 'cost-center-v2',
				children: [
					{
						path: 'create',
						element: <StaticCostCenterCreateV2 />,
					},
					{
						path: 'details',
						element: <StaticCostCenterV2 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticCostCenterV2 screen="EDIT" />,
					},
				],
			},
			{
				path: 'control-testing',
				children: [
					{
						path: 'create',
						element: <StaticControlTesting />,
					},
				],
			},
			{
				path: 'assign-control-self-assurance',
				children: [
					{
						path: 'create',
						element: <AssignControlSelfAssurance />,
					},
				],
			},
			{
				path: 'assign-control-self-assurance-v2',
				children: [
					{
						path: 'create',
						element: <AssignControlSelfAssuranceV2 />,
					},
				],
			},
			{
				path: 'leave-policy',
				children: [
					{
						path: 'create',
						element: <StaticAnnualLeaveCreate />,
					},
				],
			},
			{
				path: 'leave-combine',
				children: [
					{
						index: true,
						path: ':id',
						element: <CombinedLeaveListPage />,
					},
					{
						path: 'create',
						element: <StaticLeave />,
					},
					{
						path: 'details',
						element: <StaticLeaveUpdate screen="VIEW" />,
					},
					{
						path: 'update',
						element: <StaticLeaveUpdate screen="EDIT" />,
					},
					{
						path: 'policy',
						element: <StaticLeaveDetails />,
					},
				],
			},
			{
				path: 'leave-management',
				children: [
					{
						path: ':id',
						element: <LeaveManagement />,
					},
				],
			},
			{
				path: 'attendance-shift',
				children: [
					{
						path: 'create',
						element: <StaticAttendanceShiftCreate />,
					},
				],
			},
			{
				path: 'roster-shifts',
				children: [
					{
						index: true,
						element: <StaticRosterShiftsPolicy />,
					},
					{
						path: ':id',
						element: <StaticRosterShiftsPolicy />,
					},
					{
						path: 'create',
						element: <StaticRosterShiftsPolicy />,
					},
					{
						path: 'details',
						element: <StaticRosterShiftsPolicyDetails />,
					},
					{
						path: 'edit',
						element: <StaticRosterShiftsPolicyEdit />,
					},
				],
			},
			// {
			// 	path: 'shift-assignment',
			// 	children: [
			// 		{
			// 			path: 'create',
			// 			element: <AttendancePolicyCreate />,
			// 		},
			// 	],
			// },
			{
				path: 'accounts-assignment',
				children: [
					{
						path: 'create',
						element: <AccountsAssignmentPolicyCreate />,
					},
					{
						path: 'edit',
						element: <AccountsAssignmentPolicy screen="EDIT" />,
					},
					{
						path: 'details',
						element: <AccountsAssignmentPolicy screen="VIEW" />,
					},
				],
			},
			{
				path: 'accounts-assignment-v2',
				children: [
					{
						path: 'create',
						element: <AccountsAssignmentPolicyCreateV2 />,
					},
					{
						path: 'edit',
						element: <AccountsAssignmentPolicyEditV2 />,
					},
					{
						path: 'details',
						element: <AccountsAssignmentPolicyEditV2 />,
					},
				],
			},
			{
				path: 'cost-center-assignment',
				children: [
					{
						path: 'create',
						element: <CostCenterPolicyCreate />,
					},
					{
						path: 'edit',
						element: <CostCenterPolicy screen="EDIT" />,
					},
					{
						path: 'details',
						element: <CostCenterPolicy screen="VIEW" />,
					},
				],
			},
			{
				path: 'cost-center-assignment-v2',
				children: [
					{
						path: 'create',
						element: <CostCenterPolicyCreateV2 />,
					},
					{
						path: 'edit',
						element: <CostCenterPolicyV2 screen="EDIT" />,
					},
					{
						path: 'details',
						element: <CostCenterPolicyV2 screen="VIEW" />,
					},
				],
			},
			{
				path: 'access-control',
				children: [
					{
						path: 'create',
						element: <StaticAccessControl />,
					},
				],
			},
			{
				path: 'document-group',
				children: [
					{
						path: 'create',
						element: <StaticDocumentGroup />,
					},
				],
			},
			{
				path: 'document-hierarchy',
				children: [
					{
						path: 'create',
						element: <StaticDocumentHierarchy />,
					},
					{
						path: 'details',
						element: <StaticDocumentHierarchy screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticDocumentHierarchy screen="EDIT" />,
					},
				],
			},
			{
				path: 'file-upload',
				children: [
					{
						path: 'create',
						element: <StaticDocumentUploader />,
					},
					{
						path: 'details',
						element: <StaticDocumentUploader screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticDocumentUploader screen="EDIT" />,
					},
				],
			},
			{
				path: 'key-performance-indicator',
				children: [
					{
						path: 'create',
						element: <StaticKeyPerformanceIndicator />,
					},
					{
						path: 'details',
						element: <StaticKeyPerformanceIndicator screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticKeyPerformanceIndicator screen="EDIT" />,
					},
				],
			},
			{
				path: 'kpi-evaluation',
				children: [
					{
						path: 'create',
						element: <StaticKpiEvolution />,
					},
					{
						path: 'details',
						element: <StaticKpiEvolution screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticKpiEvolution screen="EDIT" />,
					},
				],
			},
			{
				path: 'compliance-action',
			},
			{
				path: 'vendor-invoice-submission',
				children: [
					{
						path: 'create',
						element: <StaticVendorInvoiceSubmission />,
					},
					{
						path: 'details',
						element: <StaticVendorInvoiceSubmissionViewAndEdit screen="VIEW" />,
					},
				],
			},
			{
				path: 'invoice-command-center',
				children: [
					{
						path: 'details',
						element: <StaticInvoiceCommandCenter screen="VIEW" />,
					},
				],
			},
			{
				path: 'common-escalation-matrix',
				children: [
					{
						path: 'create',
						element: <StaticCommonEscalationMatrixCreate />,
					},
					{
						path: 'edit',
						element: <StaticCommonEscalationMatrixEdit screen="EDIT" />,
					},
					{
						path: 'details',
						element: <StaticCommonEscalationMatrixEdit screen="VIEW" />,
					},
				],
			},
			{
				path: 'performance-parameter',
				children: [
					{
						path: 'create',
						element: <PerformanceParameterCreate />,
					},
				],
			},
			{
				path: 'lease-record-management-v9',
				children: [
					{
						index: true,
						path: ':id',
						element: <StaticLeaseRecordManagementDataTableV9 />,
					},
					{
						path: 'create',
						element: <StaticLeaseRecordManagementV9 screen="CREATE" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordManagementEditV9 screen="EDIT" />,
					},
					{
						path: 'revise',
						element: <StaticLeaseRecordManagementReviseV9 screen="REVISE" />,
					},
					{
						path: 'edit-new-version',
						element: <LeaseRecordManagementV9Edit />,
					},
					{
						path: 'modify-new-version',
						element: <LeaseRecordManagementV9Modify />,
					},
					{
						path: 'details',
						element: <LeaseRecordManagementV9Details screen="VIEW" />,
					},
				],
			},
			{
				path: 'lease-record-edit-v9',
				children: [
					{
						index: true,
						path: ':id',
						element: <StaticLeaseRecordEditListV9 />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordEditViewV9 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordEditV9 screen="REVISE" />,
					},
				],
			},
			{
				path: 'lease-record-modify-v9',
				children: [
					{
						index: true,
						path: ':id',
						element: <StaticLeaseRecordModifyListV9 />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordModifyViewV9 screen="VIEW" />,
					},
					{
						path: 'modify',
						element: <StaticLeaseRecordModifyV9 screen="EDIT" />,
					},
				],
			},
			{
				path: 'general-ledger-code-v9',
				children: [
					{
						path: 'create',
						element: <StaticGeneralLedgerCodeCreateV9 />,
					},
					{
						path: 'details',
						element: <StaticGeneralLedgerCodeEditV9 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticGeneralLedgerCodeEditV9 screen="EDIT" />,
					},
				],
			},
			{
				path: 'accounts-assignment-v9',
				children: [
					{
						path: 'create',
						element: <AccountsAssignmentPolicyCreateV9 />,
					},
					{
						path: 'edit',
						element: <AccountsAssignmentPolicyEditV9 screen="EDIT" />,
					},
					{
						path: 'details',
						element: <AccountsAssignmentPolicyEditV9 screen="VIEW" />,
					},
				],
			},
			{
				path: 'cost-center-v9',
				children: [
					{
						path: 'create',
						element: <StaticCostCenterCreateV9 />,
					},
					{
						path: 'details',
						element: <StaticCostCenterV9 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticCostCenterV9 screen="EDIT" />,
					},
				],
			},
			{
				path: 'cost-center-assignment-v9',
				children: [
					{
						path: 'create',
						element: <CostCenterPolicyCreateV9 />,
					},
					{
						path: 'edit',
						element: <CostCenterPolicyV9 screen="EDIT" />,
					},
					{
						path: 'details',
						element: <CostCenterPolicyV9 screen="VIEW" />,
					},
				],
			},
			{
				path: 'lease-agreement-v9',
				children: [
					{
						path: 'create',
						element: <StaticLeaseAgreementV9 />,
					},
					{
						path: 'details',
						element: <StaticLeaseAgreementDetailsV9 />,
					},
					{
						path: 'edit',
						element: <StaticLeaseAgreementEditV9 screen="EDIT" />,
					},
				],
			},
			{
				path: 'lease-simulator-v9',
				children: [
					{
						path: 'create',
						element: <StaticLeaseRecordSimulatorV9 />,
					},
					{
						path: 'details',
						element: <StaticLeaseRecordSimulatorV9 screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticLeaseRecordSimulatorV9 screen="EDIT" />,
					},
				],
			},
			{
				path: 'lease-test-bed-v9',
				children: [
					{
						path: 'create',
						element: <LeaseTrailModeV9NewCreate />,
					},
					{
						path: 'details',
						element: <LeaseV9NewTrailModeView />,
					},
					{
						path: 'edit',
						element: <LeaseV9NewTrailModeModify screen="EDIT" />,
					},
					{
						path: 'revise',
						element: <StaticLeaseRecordManagementTestBedReviseV9 screen="REVISE" />,
					},
				],
			},
			{
				path: 'chart-of-accounts',
				children: [
					{
						path: 'create',
						element: <StaticGeneralLedgerCreate />,
					},
					{
						path: 'details',
						element: <StaticGeneralLedgerView screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticGeneralLedgerEdit screen="EDIT" />,
					},
				],
			},
			{
				path: 'asset-master-data',
				children: [
					{
						path: 'create',
						element: <StaticAssetMasterDataCreate />,
					},
					{
						path: 'details',
						element: <StaticAssetMasterDataView screen="VIEW" />,
					},
					{
						path: 'edit',
						element: <StaticAssetMasterDataView screen="EDIT" />,
					},
				],
			},
			{
				path: 'process-group-roles',
				children: [
					{
						path: 'create',
						element: <StaticProcessGroupRoleCreate />,
					},
				],
			},
			{
				path: 'control/:id',
				element: <StaticControl />,
			},
			{
				path: 'lease-schedule/:id',
				element: <LeaseSchedule />,
			},
			{
				path: 'kpi-console/:id',
				element: <KpiConsoleStatic />,
			},
			{
				path: 'salary-management/:id',
				element: <SalaryManagementConsoleStatic />,
			},
			{
				path: 'lead-pipeline/:id',
				element: <LeadPipelineConsoleStatic />,
			},
			{
				path: 'lead-kanban/:id',
				element: <LeadKanbanConsoleStatic />,
			},
			{
				path: 'lead-ingestion-pool/:id',
				element: <LeadIngestionPoolConsoleStatic />,
			},
			{
				path: 'lead-screening/:id',
				element: <LeadScreeningConsoleStatic />,
			},
			{
				path: 'lead-assignment/:id',
				element: <LeadAssignmentConsoleStatic />,
			},
			{
				path: 'lead-workbench/:id',
				element: <LeadWorkbenchConsoleStatic />,
			},
			{
				path: 'team-kpi-evaluation/:id',
				element: <TeamKpiEvaluationStatic />,
			},
			{
				path: 'my-attendance/:id',
				element: <AttendanceSummary />,
			},
			{
				path: 'budgetary-control/:id',
				element: <BudgetaryControl />,
			},
			{
				path: 'invoice-ap-console',
				children: [
					{
						index: true,
						path: ':id',
						element: <InvoiceAPConsole />,
					},
					{
						path: 'details',
						element: <StaticInvoiceAPConsole screen="VIEW" />,
					},
				],
			},
			{
				path: 'invoice-treasury-console',
				children: [
					{
						index: true,
						path: ':id',
						element: <InvoiceTreasuryConsole />,
					},
					{
						path: 'details',
						element: <StaticInvoiceTreasuryConsole screen="VIEW" />,
					},
				],
			},
			{
				path: 'lease-schedule-v2/:id',
				element: <LeaseSecondConsoleV2 />,
			},
			{
				path: 'lease-schedule-v4/:id',
				element: <LeaseSecondConsoleV4 />,
			},
			{
				path: 'lease-schedule-v5/:id',
				element: <LeaseSecondConsoleV5 />,
			},
			{
				path: 'lease-schedule-v6/:id',
				element: <LeaseSecondConsoleV6 />,
			},
			{
				path: 'lease-schedule-v9/:id',
				element: <LeaseSecondConsoleV9 />,
			},
			{
				path: 'lease-accounting-v10/:id',
				element: <LeaseAccountingV10 />,
			},
			{
				path: 'lease-schedule-v7/:id',
				element: <LeaseSecondConsoleV7 />,
			},
			{
				path: 'lease-payable-v9/:id',
				element: <StaticLeasePayableV9Console />,
			},
			{
				path: 'lease-payable-approval-v9/:id',
				element: <StaticLeasePayableApprovalV9Console />,
			},
			{
				path: 'tax-payable/:id',
				element: <StaticTaxPayableConsole />,
			},
			{
				path: 'attendance-management/:id',
				element: <AttendanceManagement />,
			},
			{
				path: 'control-self-assurance/:id',
				element: <ControlSelfAssurance />,
			},
			{
				path: 'control-self-assurance-v2/:id',
				element: <ControlSelfAssuranceV2 />,
			},
			{
				path: 'petty-cash-float-dashboard/:id',
				element: <ListViewPettyCashFloatConsole />,
			},
			{
				path: 'decommission-asset-accounting/:id',
				element: <DecommissionAssetAccounting />,
			},
			{
				path: 'petty-cash-transaction/:id',
				element: <ListViewPettyCashTransactionConsole />,
			},
			{
				path: 'petty-cash-transaction-for-cashier/:id',
				element: <PettyCashTransactionForCasher />,
			},
			{
				path: 'petty-cash-reconciliation-dashboard/:id',
				element: <ListViewPettyCashReconciliationConsole />,
			},
			{
				path: 'fixed-asset-register/:id',
				element: <ListViewFixedAssetRegisterConsole />,
			},
			{
				path: 'kpi-comparative-console/:id',
				element: <KpiComparativeConsole />,
			},
			{
				path: 'acting-position-overview/:id',
				element: <ActingPositionOverview />,
			},
			{
				path: 'rate-agreement/:id',
				element: <RateAgreement />,
			},
			{
				path: 'project-milestone/:id',
				element: <ProjectMilestone />,
			},
			{
				path: 'rental-subscription/:id',
				element: <RentalSubscription />,
			},
			{
				path: 'consolidated-contract-administration/:id',
				element: <ConsolidatedContractAdministration />,
			},
		],
	},
];
export default StaticSolutionRoutes;
